import { FC } from 'react';

import { ProductPrice, TFullRentProduct } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';
import { getPercentDiff } from '@/shared/utils/get-percent-diff';

import * as Styled from './styled';

type TProps = {
    product: TFullRentProduct;
};

export const ArentaPriceInfo: FC<TProps> = ({ product }) => {
    const { priceForSevenDays, priceForThirtyDays } = product.prices;

    const { t } = useTranslate();

    return (
        <Styled.Wrapper>
            <ProductPrice title={t('за 7 дней')} value={priceForSevenDays} />
            <ProductPrice
                title={t('от месяца')}
                discount={getPercentDiff(priceForSevenDays, priceForThirtyDays)}
                value={priceForThirtyDays}
            />
        </Styled.Wrapper>
    );
};
